module.exports = __webpack_public_path__ + "img/Speaker=Jihoon Jeong.35bb8c33.png";